import React from 'react';
import queryString from 'query-string';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getIsMobile } from 'Store/Screen/selectors';
import { fetchOrderConfirmation, fetchClearOrder } from 'Store/Order/thunks';
import { PaymentStatus, DeliveryCode, OrderPage } from 'Store/Order/enums';
import OrderConfirmationPage from 'Pages/OrderConfirmationPage/OrderConfirmationPage';

import { 
  getOrderID, 
  getPaymentStatus, 
  getIsFetchingOrder, 
  getSelectedDeliveryCode,
  getOrderBarcode,
} from 'Store/Order/selectors';

const SWISH_AUTOPOLLING_INTERVAL_IN_MS = 3000;

interface IPropsInternal {
  isMobile: boolean;
  isFetching: boolean;
  orderID: number;
  transactionID: string;
  orderBarcode: string;
  paymentStatus: PaymentStatus;
  deliveryCode: DeliveryCode;
  fetchClearOrder: () => void;
  fetchOrderConfirmation: (transactionID: string, responseCode: string, isAutomaticPolling: boolean) => void;
}

interface IState {
  isSwish: boolean;
  isAutoPolling: boolean;
  transactionID: string;
  responseCode: string;
}

type Props = IPropsInternal  & RouteComponentProps<{ orderItemID: string }>;

class OrderConfirmationPageContainer extends React.PureComponent<Props, IState> {
  timer: NodeJS.Timer;
  constructor(props: Props) {
    super(props);
    this.state = {
      isSwish: false,
      isAutoPolling: false,
      transactionID: undefined,
      responseCode: undefined      
    };
  }

  componentDidMount() {
    const queryParams = queryString.parse(this.props.location.search);
    const { transactionId, responseCode, isSwish} = queryParams;
    this.setState({isSwish : isSwish, transactionID : transactionId, responseCode : responseCode});
    this.props.fetchOrderConfirmation(transactionId, responseCode, false);

    // Schedule payment status auto updates for Swish case
    if (isSwish) {
      this.startSwishAutoPolling();
    }
  }

  componentWillUnmount() {
    // Cancel payment status auto updates for Swish case
    this.stopSwishAutoPolling();
  }

  componentWillReceiveProps(nextProps: Props) {
    const { paymentStatus } = nextProps;

    if (paymentStatus !== this.props.paymentStatus) {
      switch (paymentStatus) {
        case PaymentStatus.PAID:
          this.stopSwishAutoPolling();
          break;
        case PaymentStatus.DENIED:
          this.stopSwishAutoPolling();
          this.redirectTo(OrderPage.DENIED);
          break;
        case PaymentStatus.ERROR:
          this.stopSwishAutoPolling();
          this.redirectTo(OrderPage.DENIED);
          break;        
        case PaymentStatus.PAYMENT_ERROR: {
          this.stopSwishAutoPolling();
          this.redirectTo(OrderPage.DENIED);
          break;
        }
      }
    }
  }

  startSwishAutoPolling = () => {
    console.log("Swish auto polling started");
    this.timer = setInterval(()=> {
      console.log("Swish auto polling -> fetchOrderConfirmation");
      this.setState({isAutoPolling : true});
      this.props.fetchOrderConfirmation(this.state.transactionID, this.state.responseCode, true);
    }, SWISH_AUTOPOLLING_INTERVAL_IN_MS);
  }

  stopSwishAutoPolling = () => {
    console.log("Swish auto polling stopped");
    clearInterval(this.timer);
    this.timer = null;
  }

  redirectTo = (page: string) => {
    const { history, match } = this.props;
    const { orderItemID } = match.params;
    history.replace(`/order/${ orderItemID }${ page }`);
  }

  onSwishPaymentStatus = () => {
    this.setState({isAutoPolling : false});
    this.props.fetchOrderConfirmation(this.state.transactionID, this.state.responseCode, false);
  }

  onSwishPaymentOk = () => {
    this.setState({isAutoPolling : false});
    this.stopSwishAutoPolling();
  }

  onFinish = () => {
    this.props.fetchClearOrder();
    this.props.history.replace('/');
  }
  
  render() {
    return (
      <OrderConfirmationPage 
        isMobile={ this.props.isMobile }
        isPaid={ this.props.paymentStatus === PaymentStatus.PAID }
        isFetching={ this.props.isFetching }
        isSwish={ this.state.isSwish }
        isAutoPolling={ this.state.isAutoPolling }
        orderID={ this.props.orderID }
        orderBarcode={ this.props.orderBarcode }
        deliveryCode={ this.props.deliveryCode }
        onSwishPaymentStatus={ this.onSwishPaymentStatus }
        onFinish={ this.onFinish }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isMobile: getIsMobile(state),
    isFetching: getIsFetchingOrder(state),
    orderID: getOrderID(state),
    orderBarcode: getOrderBarcode(state),
    paymentStatus: getPaymentStatus(state),
    deliveryCode: getSelectedDeliveryCode(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchClearOrder,
    fetchOrderConfirmation,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderConfirmationPageContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage/OrderConfirmationPageContainer.tsx